module.exports = __webpack_public_path__ + "static/fonts/PingFangJian.a39de04.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/comment/font/PingFangJian.ttf
// module id = zZ9B
// module chunks = 133